import { render, staticRenderFns } from "./m-child.vue?vue&type=template&id=46cd3e05&"
import script from "./m-child.vue?vue&type=script&lang=js&"
export * from "./m-child.vue?vue&type=script&lang=js&"
import style0 from "./m-child.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports